import fullpage from 'fullpage.js'
import Swiper, { Autoplay, EffectFade, Pagination } from 'swiper'

Swiper.use([Autoplay, EffectFade, Pagination])

const panels = Array.from(document.querySelectorAll('.home-panel'))

const fn = {
  init: () => {
    fn.setupProductSlider()

    new fullpage('#main-content', {
      licenseKey: '9BA5764A-0CF54B26-8FC63470-8461F116',
      keyboardScrolling: false,
      recordHistory: false,
      paddingTop: window.getComputedStyle(document.documentElement).getPropertyValue('--site-header-height'),
      fixedElements: '.site-header',
      onLeave: (origin, destination) => {
        fn.handlePanelExit(origin.item)
        fn.handlePanelEnter(destination.item)
      },
    })
    fn.handlePanelEnter(panels[0])
  },

  handlePanelExit: (panel) => {
    if (!panel.classList.contains('home-panel')) {
      return
    }
  },

  handlePanelEnter: (panel) => {
    if (!panel.classList.contains('home-panel')) {
      return
    }
  },

  setupProductSlider: () => {
    const panel = document.querySelector('.product-slider')
    const container = panel.querySelector('.swiper')
    const numSlides = container.querySelectorAll('.swiper-slide').length

    if (numSlides > 1) {
      const firstSlide = container.querySelector('.swiper-wrapper .swiper-slide:first-child')

      if (firstSlide) {
        document.documentElement.style.setProperty('--product-slider-active-color', firstSlide.dataset.color)
      }

      const swiper = new Swiper(container, {
        speed: 1000,
        autoplay: {
          delay: 4000,
        },
        loop: true,
        simulateTouch: false,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        pagination: {
          el: '.product-slider-pagination',
          clickable: true,
        },
      })

      swiper.on('slideChange', (swiper) => {
        let currentSlide = swiper.slides[swiper.realIndex + 1]
        document.documentElement.style.setProperty('--product-slider-active-color', currentSlide.dataset.color)
      })
    }
  },
}

export default {
  can: () => document.body.classList.contains('pagetype-homepage'),
  run: fn.init,
}
